<template>
    <Page :header="header[lang].name">
        <template #body>
            <div class="flex w-full flex-column px-4">
                <ol >
                    <li v-for="point in points" ><p>{{point[lang] }}</p></li>
                </ol>
            </div>
        </template>
    </Page>
</template>

<script>
import Page from '@/components/sides/Page.vue'

export default {
    data() {
        return {
            header:{
                en: {name: "Instruction"} ,
                ru: {name: "Инструкция"} ,
            },
            buttons:  {
                en:{
                    main : "Main",
                    transfer: "Create a transfer",
                },
                ru:{
                    main : "Главная страница",
                    transfer: "Создать перевод",
                }                 
            }, 
            points: [
                {
                    ru: "Зарегистрируйтесь на странице Регистрация",
                    en: "Register on the Registration page"
                },
                {
                    ru: "Перейти на страницу «Создание перевода»",
                    en: "Go to the «Create a transfer» page"
                },
                {
                    ru: "Выберите валюту отправки и получения, а также укажите сумму перевода",
                    en: "Select the currency of sending and receiving, as well as indicate the amount of the transfer",
                },
                {
                    ru: "Выберите банк, с которого вы собираетесь совершить перевод",
                    en: "Select the bank from which you are going to make a transfer",
                },
                {
                    ru: "Убедитесь, что имя отправителя совпадает с именем владельца карты, с которой вы совершаете перевод",
                    en: "Make sure that the sender's name matches the name of the cardholder from which you are making the transfer",
                },
                {
                    ru: "Выберите банк получателя или способ получения перевода, например электронный кошелек",
                    en: "Select the recipient's bank or method of receiving the transfer, for example, an electronic wallet",
                },
                {
                    ru: "Введите данные получателя платежа, это могут быть: номер телефона, фамилия и имя получателя (на английском языке для переводов в Индонезию), номер счета получателя",
                    en: "Enter the details of the recipient, these can be: phone number, recipient's last name and first name (in English for transfers to Indonesia), recipient's account number",
                },
                {
                    ru: "Ознакомьтесь с условиями, комиссиями, итоговой суммой квитанции и нажмите «Создать перевод»",
                    en: "Read the terms, commissions, the final amount of the receipt and click «Create a transfer»"
                },
                {
                    ru: `Вы окажетесь на странице перевода с реквизитами получателя и суммой платежа. Проверьте реквизиты отправителя и получателя. Если все верно, то совершите платеж предложенным способом и по указанным реквизитам.`,
                    en: `You will be taken to the transfer page with the recipient's details and the payment amount. Check the details of the sender and recipient. If everything is correct, then make a payment in the proposed way and according to the specified details.`
                },
                {
                    ru: "Обязательно нажмите нопку «Я оплатил». В противном случае мы не увидим ваш платеж и не сможем отправить деньги получателю. После подтверждения оплаты статус перевода изменится на «В процессе» и мы начнем обработку перевода.",
                    en: "Be sure to click the «I paid» button. Otherwise, we will not see your payment and will not be able to send money to the recipient. After confirming the payment, the transfer status will change to «process» and we will start processing the transfer."
                },
                {
                    ru: "Дождитесь подтверждения оплаты. После подтверждения оплаты мы отправим деньги получателю и статус перевода изменится на «Выполнен» в зеленом цвете.",
                    en: "Wait for payment confirmation. After confirming the payment, we will send the money to the recipient and the transfer status will change to «Completed» in green."
                }
            ]        
        }
    },
    components: {
        Page
    },
    methods: {
        go_main(){
            this.$router.push({
                path: '/'
            })
        },
        go_transfer(){
            this.$router.push({
                path: '/personal/transfer/create/'
            })
        }
    },
    computed: {
        lang() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        },
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
    },
    mounted(){

    }
}
</script>